<script lang="ts">
  import('App/Dealerships').then((m) => {
    let module = m.default;

    new module({
      target: document.getElementById('dealerships'),
      layout: 'auto',

      props: {
        schema: {
          visibility: {
            readOnly: true,
          },
        },
      },
    });
  });
</script>

<div id="dealerships" />
